
export const useDashboardMenu = () => {
    const getItems = () => {
        const menuItems = [
        ];
        return menuItems;
    }
    return { getItems }
}